export enum CreateQuotationStepsEnum {
  CUSTOMER_DETAILS = "customer-details",
  STORAGE_TYPES = "storage-types",
  SUMMARY = "summary",
  PRODUCTS = "products",
  ADDITIONAL_INFO = "additional-info",
  ACCESSORIES = "accessories",
  FLOOR_DETAILS = "floor-details",
  BESPOKE_ITEMS = "bespoke-items",
  SERVICES = "services",
  BOM_DETAILS = "bom-details",
  LOAD_NOTICES = "load-notice",
  // INSTALLATION_CHECKLIST = "installation-checklist",
  COLLECTION_DELIVERY = "delivery-location",
  NOTES = "notes",
  DESIGNS = "designs",
  REVIEW = "review",
}

export enum ProductSubSteps {
  PRODUCTS = "products_sub_step",
  ACCESSORIES_AND_PARTS = "accessories_parts_sub_step",
}

export const STATIC_GROUP_CHILDREN = [
  // { key: CreateQuotationStepsEnum.SUMMARY, label: "Summary" },
  { key: CreateQuotationStepsEnum.PRODUCTS, label: "Products" },
  {
    key: CreateQuotationStepsEnum.ACCESSORIES,
    label: "Accessories and Replacement Parts",
  },
];

export const isMezzanineCategory = (cat: any) => {
  const slug = (cat?.slug || "").toLowerCase();
  const name = (cat?.name || "").toLowerCase();
  const productTypeName = (cat?.product_type_name || "").toLowerCase();
  return (
    slug.includes("mezzanine") ||
    name.includes("mezzanine") ||
    productTypeName.includes("mezzanine")
  );
};

export const getChildrenForCategory = (cat: any) => {
  if (isMezzanineCategory(cat)) {
    return [{ key: CreateQuotationStepsEnum.FLOOR_DETAILS, label: "Floor Details" }];
  }
  return STATIC_GROUP_CHILDREN;
};

export enum QuoteStatus {
  DRAFT = "draft",
  SAVED = "saved",
  SENT = "sent",
  DESIGN_APPROVED = "design_approved",
  APPROVED = "approved",
  // REJECTED = "rejected",
  DESIGN_PENDING = "design_pending",
  EXPIRED = "expired",
  APPROVED_OVERRIDE = "approved_override",
  ORDER_CREATED = "order_created",
  PENDING_ADMIN_APPROVAL = "pending_admin_approval",
  ADMIN_APPROVED = "admin_approved",
}

export const QuoteStatusLabels: Record<QuoteStatus, string> = {
  [QuoteStatus.DRAFT]: "Draft",
  [QuoteStatus.SAVED]: "Save",
  [QuoteStatus.SENT]: "Sent",
  [QuoteStatus.DESIGN_APPROVED]: "Design Approved",
  [QuoteStatus.APPROVED]: "Approved",
  // [QuoteStatus.REJECTED]: "Rejected",
  [QuoteStatus.DESIGN_PENDING]: "Pending Design Approval",
  [QuoteStatus.EXPIRED]: "Expired",
  [QuoteStatus.APPROVED_OVERRIDE]: "Approved Override",
  [QuoteStatus.ORDER_CREATED]: "Order Created",
  [QuoteStatus.PENDING_ADMIN_APPROVAL]: "Pending Admin Approval",
  [QuoteStatus.ADMIN_APPROVED]: "Admin Approved",
};

export const QuoteStatusColors: Record<QuoteStatus, string> = {
  [QuoteStatus.DRAFT]: "default", // Gray
  [QuoteStatus.SAVED]: "default",
  [QuoteStatus.SENT]: "processing", // Blue
  [QuoteStatus.DESIGN_APPROVED]: "cyan",
  [QuoteStatus.APPROVED]: "success", // Green
  // [QuoteStatus.REJECTED]: "error", // Red
  [QuoteStatus.DESIGN_PENDING]: "warning", // Orange/Gold
  [QuoteStatus.EXPIRED]: "error",
  [QuoteStatus.APPROVED_OVERRIDE]: "purple",
  [QuoteStatus.ORDER_CREATED]: "success",
  [QuoteStatus.PENDING_ADMIN_APPROVAL]: "pink",
  [QuoteStatus.ADMIN_APPROVED]: "green",
};

export const getQuoteStatusOptions = () => {
  // Allowed statuses: DRAFT, SENT, EXPIRED, ORDER_CREATED, PENDING_ADMIN_APPROVAL, ADMIN_APPROVED
  const allowedStatuses: QuoteStatus[] = [
    QuoteStatus.DRAFT,
    QuoteStatus.SENT,
    QuoteStatus.EXPIRED,
    QuoteStatus.ORDER_CREATED,
    QuoteStatus.PENDING_ADMIN_APPROVAL,
    QuoteStatus.ADMIN_APPROVED,
  ];

  // return Object.values(QuoteStatus).filter((v) => v !== QuoteStatus.APPROVED && v !== QuoteStatus.APPROVED_OVERRIDE).map((value) => ({
  //   label: QuoteStatusLabels[value],
  //   value: value,
  // }));

  return allowedStatuses.map((value) => ({
    label: QuoteStatusLabels[value],
    value: value,
  }));
};

export enum PaymentMilestoneStatus {
  PENDING = "pending",
  PAID = "paid",
  OVERDUE = "overdue",
  PARTIAL = "partially_paid",
  UNPAID = "unpaid",
}

export const PaymentMilestoneStatusLabels: Record<
  PaymentMilestoneStatus,
  string
> = {
  [PaymentMilestoneStatus.PENDING]: "Pending",
  [PaymentMilestoneStatus.PAID]: "Paid",
  [PaymentMilestoneStatus.OVERDUE]: "Overdue",
  [PaymentMilestoneStatus.PARTIAL]: "Partially Paid",
  [PaymentMilestoneStatus.UNPAID]: "Unpaid",
};

export const getPaymentMilestoneStatusOptions = () => {
  return Object.values(PaymentMilestoneStatus).map((value) => ({
    label: PaymentMilestoneStatusLabels[value],
    value: value,
  }));
};

// --- ADDITIONAL INFO TYPES ---
export interface InfoMetadata {
  info_for: "accessory" | "service" | string;
  info_value: { slug: string }[];
}

export interface AdditionalInfoValue {
  name: string;
  image: string | null;
  slug: string;
  should_selected: boolean;
  required_keys: string[];
  info: InfoMetadata[];
  order: number;
}

export type AdditionalInfoType =
  | "toggle_with_values"
  | "check_box"
  | "toggle_with_boolean";

export interface AdditionalInfoField {
  _id: string;
  key: string;
  name: string;
  type: AdditionalInfoType;
  order: number;
  value: AdditionalInfoValue[];
  is_active: number;
}

export const QUOTATION_SCROLL_KEY = "quotations_scroll_top";
export const QUOTATION_FILTER_KEY = "quotations_filters";
export const QUOTATION_REFETCH_KEY = "quotations_needs_refetch";

export enum WarningSeverity {
  BLOCKING = "BLOCKING",
  BYPASSABLE = "BYPASSABLE",
}

export const RETAIL_PRICE_HIDDEN_TOOLTIP_TEXT = 'It will not be visible to customer';
